import { render, staticRenderFns } from "./childOutinsuranceSchool.vue?vue&type=template&id=1cd1aa98&scoped=true&"
import script from "./childOutinsuranceSchool.vue?vue&type=script&lang=js&"
export * from "./childOutinsuranceSchool.vue?vue&type=script&lang=js&"
import style0 from "./childOutinsuranceSchool.vue?vue&type=style&index=0&id=1cd1aa98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd1aa98",
  null
  
)

export default component.exports